import React, { ReactNode } from "react";
import PropTypes from "prop-types";
import theme from "@/assets/theme";
import useStyles from "./AppTitle.style";
import { useMediaQuery } from "@mui/material";
import { useRouter } from "next/router";

interface IAppTitleProps {
  title: string;
  color?: string;
  fontSize?: string;
  styleTitle?: React.CSSProperties;
  upperCase?: boolean;
}

function AppTitle(props: IAppTitleProps) {
  const { locale } = useRouter();
  const availableColors = [
    "#333",
    "#547FA0",
    "#43ABAE",
    "#CE5B61",
    "#4B2884",
    "#fff",
    "#00355F",
  ];

  const isDownMd = useMediaQuery(theme.breakpoints.down("md"));

  const selectedColor =
    props.color ||
    availableColors[Math.floor(Math.random() * availableColors.length)];

  const fontSize = props.fontSize ?? isDownMd ? "24px" : "40px";

  const { classes } = useStyles({
    params: {
      selectedColor: selectedColor,
      fontSize: fontSize,
      locale: locale!,
    },
  });

  return (
    <div className="colored-title">
      <h1 className={classes.title} style={props.styleTitle}>
        {props.upperCase ? props.title.toUpperCase() : props.title}
      </h1>
    </div>
  );
}

AppTitle.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
};

export default AppTitle;
